var map = {
	"./ED1.jpeg": "1a22",
	"./ED2.jpeg": "2b09",
	"./ED3.jpeg": "0925",
	"./NP10.jpeg": "5c88",
	"./NP11.jpeg": "9c18",
	"./NP4.jpeg": "6287",
	"./NP5.jpeg": "0e54",
	"./NP6.jpeg": "a887",
	"./NP7.jpeg": "97e8",
	"./NP8.jpeg": "c80d",
	"./NP9.jpeg": "dc0d",
	"./VA1.jpeg": "137c",
	"./VA2.jpeg": "ffd3",
	"./VA3.jpeg": "fa48",
	"./VA4.jpeg": "57d9",
	"./a0.jpg": "ebe0",
	"./a1.jpg": "fec2",
	"./a10.jpg": "ea4b",
	"./a11.jpg": "bd84",
	"./a12.jpg": "0d49",
	"./a13.jpg": "2dbf",
	"./a2.jpg": "6085",
	"./a3.jpg": "bdcd",
	"./a4.jpg": "c78e",
	"./a5.jpg": "cf28",
	"./a6.jpg": "5e2d",
	"./a7.jpg": "76a0",
	"./a8.jpg": "bb89",
	"./a9.jpg": "64e3",
	"./classGroupPic.jpeg": "3fda",
	"./g1.jpg": "6a5d",
	"./g10.jpg": "fd16",
	"./g11.jpg": "fddd",
	"./g12.jpg": "0e53",
	"./g13.jpg": "e5fc",
	"./g14.jpg": "561e",
	"./g15.jpg": "edeb",
	"./g16.jpg": "712f",
	"./g2.jpg": "085a",
	"./g3.jpg": "3950",
	"./g4.jpg": "317b",
	"./g5.jpg": "1dd2",
	"./g6.jpg": "ce4d",
	"./g7.jpg": "145d",
	"./g8.jpg": "9e4b",
	"./g9.jpg": "15be",
	"./newFlagHost.jpeg": "3693",
	"./newStudentsGroupPic.jpeg": "67a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa0e";